import { useTheme } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
function TestimonialCard({ testimonial }) {
  const theme = useTheme();
  const S3_URL = process.env.REACT_APP_S3_URL;
  return (
    <Box 
      boxShadow={ `0px 0px 10px 0px ${theme.palette.cardShadow}`}
      gap={2}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      lineHeight={1.2}
      backgroundColor={theme.palette.common.white}
      sx={{
        width: '100%',
        padding: {
          xs: 4,
          md: 6,
          lg: 8
        },
        borderRadius: {
          xs: 5,
        },
      }}
    >
      <img
        loading='lazy'
        src={S3_URL + '/' + testimonial.img}
        alt={testimonial.alt}
        width={testimonial.width}
        height={testimonial.height}
      />
      <Box 
        component='hr' 
        backgroundColor={theme.palette.common.black} 
        width={75}
      />
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
      >

        <Typography
          component='h2'
          variant="h5"
          align={'center'}
          sx={{
            fontWeight: 700,
            color: '#131250',
          }}
        >
          <FormattedMessage id={testimonial.author}  defaultMessage={''}/>{' '}
        </Typography>
        {
          testimonial.subtitle && (
            <Typography
              component='p'
              variant="h6"
              align={'center'}
              sx={{
                fontWeight: 400,
                color: '#131250',
                textWrap: 'pretty',
                width: '70%'
              }}
            >
              <FormattedMessage id={testimonial.subtitle} defaultMessage={' '}/>{' '}
            </Typography>
          )
        }
      </Box>
      <Box 
        display={'flex'}
        flexDirection={'column'}
        gap={2}
      >
        {testimonial.p.map((p) => (
          <Typography
            key={crypto.randomUUID()}
            component='p'
            variant='p'
            align={'center'}
            sx={{
              fontWeight: 400,
              color: theme.palette.text.secondary,
              textWrap: 'balance'
            }}
          >
            <FormattedMessage id={p} />{' '}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}

TestimonialCard.propTypes = {
  testimonial: PropTypes.shape({
    img: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    author: PropTypes.string,
    subtitle: PropTypes.string,
    p: PropTypes.arrayOf([PropTypes.string]),
  }),
};
export default TestimonialCard;
